import React from "react";
import { FaUsers, FaExternalLinkAlt } from "react-icons/fa";
import "./About.min.css";

// Import images
import vnmurthyImage from "../Assests/speakers/vnmurthy.jpg";
import sinhaImage from "../Assests/speakers/sinha.jpg";
import johmImage from "../Assests/speakers/johm.jpg";
import briandillonImage from "../Assests/speakers/briandillon.png";
import adityamurthyImage from "../Assests/speakers/adityamurthy.jpg";
import nandiniImage from "../Assests/speakers/nandini.jpg";
import harisjkarnickImage from "../Assests/speakers/harisjkarnick.jpg";
import upenderbhallaImage from "../Assests/speakers/upenderbhalla.jpg";
import narayansrinivasImage from "../Assests/speakers/narayansrinivas.jpg";

const AboutUs = () => {
  const speakers = [
    { name: "Prof Venkatesh Murthy", link: "https://vnmurthylab.org/", image: vnmurthyImage },
    { name: "Prof. Pawan Sinha", link: "https://www.sinhalab.mit.edu/", image: sinhaImage },
    { name: "Prof. John Gero", link: "https://cci.charlotte.edu/directory/john-gero/", image: johmImage },
    { name: "Prof. Brian Dillon", link: "https://people.umass.edu/bwdillon/", image: briandillonImage },
    { name: "Prof. Aditya Murthy", link: "https://cns.iisc.ac.in/aditya/", image: adityamurthyImage },
    { name: "Prof. Harish Karnick", link: "https://iitk.ac.in/new/dr-harish-karnick#", image: harisjkarnickImage },
    { name: "Prof. Upinder Bhalla", link: "https://www.ncbs.res.in/faculty/bhalla", image: upenderbhallaImage },
    { name: "Prof. Narayanan Srinivasan", link: "https://sites.google.com/site/ammuns68", image: narayansrinivasImage }
  ];

  return (
    <div className="speakers-container">
      <h1 className="speakers-title">
        <FaUsers className="speakers-icon" aria-hidden="true" />
        <span>SPEAKERS</span>
      </h1>

      <div className="speakers-grid">
        {speakers.map((speaker, index) => (
          <div className="speaker-card" key={index}>
            <div className="top-bar"></div>
            <div className="speaker-content">
              <img src={speaker.image} alt={speaker.name} className="speaker-image" />
              <strong className="speaker-name">{speaker.name}</strong>
            </div>
            <div className="speaker-link">
              <a href={speaker.link} target="_blank" rel="noopener noreferrer">
                <FaExternalLinkAlt className="link-icon" aria-hidden="true" /> Visit Webpage
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutUs;